function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.319,4.999c0-0.92,0.76-1.679,1.68-1.679h19.994c0.92,0,1.68,0.758,1.68,1.679 v19.996c0,0.92-0.76,1.678-1.68,1.678H4.999c-0.92,0-1.68-0.758-1.68-1.678V4.999z M4.999,29.992h19.994 c2.76,0,4.999-2.24,4.999-4.998V4.999C29.992,2.24,27.753,0,24.993,0H4.999C2.24,0,0,2.24,0,4.999v19.996 C0,27.752,2.24,29.992,4.999,29.992z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6.678,
  y: 13.316,
  fillRule: "evenodd",
  clipRule: "evenodd",
  width: 16.676,
  height: 3.32
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6.678,
  y: 6.678,
  fillRule: "evenodd",
  clipRule: "evenodd",
  width: 16.676,
  height: 3.319
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6.678,
  y: 19.994,
  fillRule: "evenodd",
  clipRule: "evenodd",
  width: 9.998,
  height: 3.32
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.992 29.992",
    enableBackground: "new 0 0 29.992 29.992",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/description.c8a6e878.svg";
export { SvgComponent as ReactComponent };